import { Action } from 'redux'
import { DateTimeFormatActions } from '../../../reducers/userObject/actionNames'

export const changeDateTimeFormat = (
  date: string,
  time: string,
): IUserSettingsDateTime => ({
  dateFormat: date,
  timeFormat: time,
  type: DateTimeFormatActions.ChangeDateTimeFormatValues,
})

export interface IUserSettingsDateTime
  extends Action<DateTimeFormatActions.ChangeDateTimeFormatValues> {
  dateFormat: string
  timeFormat: string
}

export const validateDateTimeFormat = (
  date: string,
  time: string,
): IValidateDateTime => ({
  dateFormat: date,
  timeFormat: time,
  type: DateTimeFormatActions.ValidateDateTimeFormatValues,
})

export interface IValidateDateTime
  extends Action<DateTimeFormatActions.ValidateDateTimeFormatValues> {
  dateFormat?: string
  timeFormat?: string
}
